module.exports = "<div class=\"for-save-as-image\"><div class=\"text-center\" ng-if=\"!$ctrl.filterData.filterData.cells.length && !$ctrl.filterData.loading\n  && !$ctrl.filterData.cancelled\">{{::'Нет данных за период, попадающих под фильтр' | gettext}}</div><div class=\"total\" ng-style=\"$ctrl.totalStyle\" title=\"{{$ctrl.measureLabel}}\" ng-if=\"!$ctrl.filterData.cancelled && $ctrl.filterData.filterData.cells.length\">{{$ctrl.total}}</div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/stat/summ-stat/summ-stat.component.html
// module id = 926
// module chunks = 0